import { Autosuggest, Button, Modal, SpaceBetween } from '@cloudscape-design/components';
import React, { useEffect, useRef, useState } from 'react';


import { formatPhone } from '../pages/commons/functions';
import { useGlobalState } from '../pages/context/GlobalStateContext';
interface UserPickerProps {
    visible: boolean;
    close?: boolean;
    clear?: boolean;
    today?: boolean;
    start?: Date;
    end?: Date;
    title?: string;
    subTitle?: string;
    onDismiss: () => void;
    onConfirm: (detail: { value: string; label: string }) => void;
}

type UserItem = {
    idUser: number,
    displayName: string
    RUT: string,
    phone1: number,
    email: string,
    status: string,
    value: string,
    label: string,
    description: string,
    tags: [],
    labelTag: string,
};
const UserPicker: React.FC<UserPickerProps> = ({
    visible,
    close = false,
    clear = true,
    title = 'Seleccione',
    subTitle = 'Usuario',
    onDismiss,
    onConfirm,
}) => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    const [keyw, setKeyw] = useState<string>('');

    const [users, setUsers] = useState<UserItem[]>([]);
    const autosuggestRef = useRef<HTMLDivElement>(null);
    const handleUserSelect = ({ detail }: { detail: { value: string; label: string } }) => {
        onConfirm(detail);
        onDismiss();
    };
    if (data && data.users) {
        useEffect(() => {
            setUsers(data.users.map((user: any) => ({
                idUser: user.idUser,
                value: String(user.idUser), // ✅ ensure string
                displayName: user.displayName ?? '',
                RUT: user.RUT ?? '',
                email: user.email ?? '',
                phone1: user.phone1 ?? '',
                status: user.status ?? '',
                label: user.displayName || '(sin nombre)', // ✅ never empty
                description: user.RUT ?? '',
                tags: [formatPhone(user.phone1), user.email].filter(Boolean),
                labelTag: user.status ?? '',
            })));
        }, [data.users]);
    }
    const filteredUsers = keyw.length >= 3
        ? users
            .filter(user => {
                const searchWords = keyw.toLowerCase().split(/\s+/).filter(Boolean);
                return searchWords.every(word =>
                    user.displayName.toLowerCase().includes(word) ||
                    user.email.toLowerCase().includes(word) ||
                    user.phone1.toString().toLowerCase().includes(word) ||
                    user.status.toLowerCase().includes(word) ||
                    user.idUser.toString().toLowerCase().includes(word) ||
                    user.RUT.toLowerCase().includes(word)
                );
            })
            // ✅ Clean up to ensure no blank or undefined label/value
            .filter(u => u && u.displayName && u.idUser)
            .map(u => ({
                ...u,
                label: u.displayName.trim(),
                value: u.idUser.toString().trim(),
            }))
        : [];
    useEffect(() => {
        if (filteredUsers.length === 1) {
            onConfirm(filteredUsers[0]);
            setKeyw("")
        }
    }, [filteredUsers]);

    useEffect(() => {
        if (visible && autosuggestRef.current) {
            const input = autosuggestRef.current.querySelector('input');
            (input as HTMLInputElement | null)?.focus();
        }
    }, [visible])
    if (!users.length) return null;

    return (
        <Modal
            visible={visible}
            onDismiss={onDismiss}
            size="small"
            header={title}
            footer={<Button onClick={() => onConfirm({ label: "", value: "0" })}>Limpiar</Button>}
        >
            <SpaceBetween direction="vertical" size="xs">
                <div ref={autosuggestRef}>
                    <Autosuggest
                        hideEnteredTextOption
                        value={keyw}
                        onChange={({ detail }) => setKeyw(detail.value)}
                        onSelect={({ detail }) => {
                            const option = detail.selectedOption;
                            if (option && option.value) {
                                handleUserSelect({ detail: { value: option.value, label: option.label ?? '' } });
                            }
                        }}
                        onFocus={() => {

                        }}
                        options={filteredUsers}
                        placeholder="Ingrese usuario"
                        filteringType="none"
                        enteredTextLabel={undefined}  // 🚫 prevents the blank “Use entered text” option
                    />

                </div>
            </SpaceBetween>
        </Modal >
    );
};

export default UserPicker;